import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import Notification from "../components/common/Notification";
import { FaEdit, FaTrash, FaPlus } from "react-icons/fa";
import styles from "./AdminPage.module.css";

function AdminProductsPage() {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [notification, setNotification] = useState(null);

  const showToast = (message, type = "success") => {
    setNotification({ message, type });
  };

  const fetchProducts = async () => {
    try {
      const response = await fetch("/api/cms/products");
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      const productsOnly = data.filter((p) => p.category?.type === "Product");
      setProducts(productsOnly);
      setIsLoading(false);
    } catch (error) {
      showToast("Could not fetch products.", "error");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchProducts();
  }, []);

  const handleDelete = async (productId, productName) => {
    if (window.confirm(`Are you sure you want to delete "${productName}"?`)) {
      // --- FIX: GET KEY ---
      const adminKey = localStorage.getItem("adminKey");

      try {
        const response = await fetch(`/api/cms/products/${productId}`, {
          method: "DELETE",
          // --- FIX: SEND HEADER ---
          headers: {
            "x-admin-key": adminKey,
          },
        });

        if (response.status === 200 || response.status === 204) {
          setProducts(products.filter((p) => p._id !== productId));
          showToast(`Product "${productName}" deleted successfully.`, "danger");
        } else {
          showToast(`Failed to delete product.`, "error");
        }
      } catch (error) {
        showToast("Network error.", "error");
      }
    }
  };

  return (
    <div className={styles.adminPage}>
      <Navbar />

      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}

      <div className={styles.adminHero}>
        <h1>Manage Products</h1>
        <Link
          to="/admin/products/new"
          className={`${styles.adminBtn} ${styles.primary}`}
        >
          <FaPlus /> Add New Product
        </Link>
      </div>

      <div className={styles.adminContentContainer}>
        <div className={styles.adminTableContainer}>
          <table className={styles.adminTable}>
            <thead>
              <tr>
                <th>Image</th>
                <th>Name</th>
                <th>Category</th>
                <th>Price / Info</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    Loading...
                  </td>
                </tr>
              ) : products.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    No products found.
                  </td>
                </tr>
              ) : (
                products.map((product) => (
                  <tr key={product._id}>
                    <td>
                      {product.imageURL ? (
                        <img
                          src={`${product.imageURL}`}
                          alt={product.name}
                          className={styles.tableImg}
                        />
                      ) : (
                        <div
                          className={styles.tableImg}
                          style={{
                            backgroundColor: "#111",
                            color: "#555",
                            fontSize: "0.7rem",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          No Img
                        </div>
                      )}
                    </td>
                    <td>{product.name}</td>
                    <td>{product.category ? product.category.name : "N/A"}</td>
                    <td className={styles.tablePrice}>
                      {product.price > 0 ? `${product.price} Br` : "N/A"}
                    </td>
                    <td className={styles.tableActions}>
                      <Link
                        to={`/admin/products/edit/${product._id}`}
                        className={`${styles.adminBtn} ${styles.iconBtn}`}
                        title="Edit"
                      >
                        <FaEdit />
                      </Link>
                      <button
                        className={`${styles.adminBtn} ${styles.iconBtn} ${styles.danger}`}
                        title="Delete"
                        onClick={() => handleDelete(product._id, product.name)}
                      >
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <Link to="/admin/dashboard" className={styles.adminBackLink}>
          &larr; Back to Dashboard
        </Link>
      </div>
      <Footer />
    </div>
  );
}

export default AdminProductsPage;
